import { AxiosResponse } from 'axios'
import { loginType } from '../Components/Login/login.schema'
import { signupType } from '../Components/Signup/signup.schema'
import { resetPasswordType } from '../Pages/ResetPassword/ResetPassword.schema'
import { LoginAndGetUserResponse, LoginResponse } from '../types/api.types'
import { AxiosService } from './axios.service'
import { UserModel } from '../models/user.model'
import { store } from '../store/store'
import { updateProfile } from '../store/profile-data.slice'

export class AuthService {
  private static instance: AuthService
  private axiosService = AxiosService.getInstance()

  private constructor() {}

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService()
    }
    return AuthService.instance
  }

  signup(data: signupType): Promise<AxiosResponse<any>> {
    const url = 'api/User/Register'
    return this.axiosService.post<any>(url, data)
  }

  login(data: loginType): Promise<AxiosResponse<LoginResponse>> {
    const url = 'api/User/login'
    return this.axiosService.post<LoginResponse>(url, data)
  }

  async getUserDataAndUpdateStore(): Promise<UserModel> {
    // const url = "api/User/GetUser";
    const url = '/customer/me'
    const response = await this.axiosService.getWithToken<UserModel>(url)

    const user = new UserModel(response.data)

    localStorage.setItem('@user', JSON.stringify(user))
    store.dispatch(updateProfile(user))
    return user
  }

  validateToken(): Promise<AxiosResponse<any>> {
    const url = `/auth/token/validate`
    // It will automatically try to refresh the tokens

    const { accessToken, refreshToken } = this.axiosService.getTokens()
    return this.axiosService.postWithToken<any>(url, {
      accessToken: accessToken,
      refreshToken: refreshToken,
    })
  }

  forgetPassword(email: string): Promise<AxiosResponse<any>> {
    const url = `api/User/ForgotPassword`
    return this.axiosService.post<any>(url, email)
  }

  resetPassword(data: resetPasswordType): Promise<AxiosResponse<any>> {
    const url = `api/User/ResetPassword`
    return this.axiosService.post<any>(url, data)
  }

  // Phone verification methods
  sendOTP(
    countryCode: string | undefined,
    phoneNumber: string | undefined,
    email: string,
    via: 'sms' | 'email',
  ): Promise<AxiosResponse<any>> {
    const url = '/auth/customer/otp/send'
    return this.axiosService.postWithToken<any>(url, { countryCode, phoneNumber, email, via })
  }

  verifyOTP(data: {
    countryCode?: string
    phoneNumber?: string
    email: string
    name?: string
    otp: string
    via: 'sms' | 'email'
  }): Promise<AxiosResponse<LoginResponse>> {
    const url = '/auth/customer/otp/verify'
    return this.axiosService.postWithToken<LoginResponse>(url, data)
  }
}
